import Api from "../../service";

async function platformGuard(data){
    return await Api.post('/api/v1/Auth/PlatformGuard',data);
}
export default platformGuard;